import React, { useContext, useState } from 'react';
import { Grid, Modal } from '@mui/material';
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import BulkUploadModal from 'components/Monitor/Modals/BulkUploadModal';
import { GlobalContext } from '../../../providers/GlobalProvider';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
  helpContent?: any;
}

const CustomModuleHeaderLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const { children, title, helpContent } = props;
  const [ bulkUploadModalOpen, setBulkUploadModalOpen ] = useState(false);
  const { cur_user } = useContext(GlobalContext);

  const handleBulkUploadModalOpen = () => {
    setBulkUploadModalOpen(true);
  };

  const handleBulkUploadModalClose = () => {
    setBulkUploadModalOpen(false);
  };

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <div className='module-header-breadcrumbs'>
              {title.includes('Classify') ? (
                <h1 className='analyzers-page-title'>{title}</h1>
              ) : (
                <Link to='/bite-monitor'>
                  <h1
                    className='analyzers-page-title'
                    style={{ cursor: 'pointer' }}
                  >
                    {title}
                  </h1>
                </Link>
              )}
              <div className='module-header-title-conts'>
                {helpContent && (
                  <div className='module-header-btns'>
                    <Tooltip
                      title={helpContent}
                      placement='bottom-start'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            'display': 'flex',
                            'padding':
                              'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            'flexDirection': 'column',
                            'alignItems': 'flex-start',
                            'alignSelf': 'stretch',
                            'borderRadius': 'var(--radius-md, 8px)',
                            'background': 'var(--Background-200, var(--bg-colors))',
                  'color': 'var(--text-prim25)',
                            'maxWidth': '700px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, var(--bg-colors))'
                            }
                          },
                        },
                      }}
                    >
                      <div className='module-header-help'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <g clipPath='url(#clip0_16034_866)'>
                            <path
                              d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z'
                              stroke='#94969C'
                              strokeWidth='1.66667'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_16034_866'>
                              <rect width='20' height='20' fill='white' />
                            </clipPath>
                          </defs>
                        </svg>
                        <p>Help</p>
                      </div>
                    </Tooltip>
                  </div>
                )}
                {cur_user.bite_super_admin && title.includes('Saved Work') && (
                  <>
                    <button
                      className='btn-new-automate'
                      onClick={handleBulkUploadModalOpen}
                    >
                      <div>Bulk Upload</div>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
      <Modal open={bulkUploadModalOpen} onClose={handleBulkUploadModalClose}>
        <BulkUploadModal
          handleClose={handleBulkUploadModalClose}
          isOpen={bulkUploadModalOpen}
        />
      </Modal>
    </section>
  );
};

export default CustomModuleHeaderLayout;
